import React, { Component } from "react";
import { convertStringToElements } from "@vds/html-parsers";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { compose } from "redux";
import { withRouter } from "react-router-dom";

import { fetchDownloadAndDeleteLanding } from "../../actions";
import { resetCancelDownloadType } from "../../../DownloadAndDelete/actions";
import { handleAEMReactLink } from "utils/handleAEMReactLink";

import Alert from "common-components/Alert";
import { replaceHashValues } from "utils/replaceHashValues";
import { checkAMLob } from "utils/checkAMLob";

class YourRequestBanner extends Component {
  state = {
    timeStamp: null
  };

  componentDidMount() {
    this.props.fetchDownloadAndDeleteLanding();

    if (this.props.cancelDownloadType) {
      this.handleEventListener("add");
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.timeStamp !== prevState.timeStamp) {
      this.handleEventListener("remove");
      
      setTimeout(() => {
        handleAEMReactLink();
      }, 1);
    }
  }

  componentWillUnmount() {
    this.handleEventListener("remove");
  }

  handleEventListener = type => {
    if (type === "add") {
      document.addEventListener("click", this.handleUserClick);
      document.addEventListener("keydown", this.handleUserClick);
    } else {
      this.props.resetCancelDownloadType();
      document.removeEventListener("click", this.handleUserClick);
      document.removeEventListener("keydown", this.handleUserClick);
    }
  };

  handleUserClick = ({ timeStamp }) => {
    this.setState({
      timeStamp
    });
  };

  renderMainHeaderButton = () => {
    const {
      download_complete,
      download_pending,
      delete_pending,
      delete_complete,
      download_extension,
      suspended_no_email,
      suspended_pending_email,
      appeal_pending,
      correct_in_progress,
      generic_error
    } = this.props.bannerContent;
    const {
      requestType,
      status,
      downloadReady,
      cancelDownloadType,
      shouldBannerRender,
      lastExtensionTaken,
      hasExtension,
      pageContent,
      suspendedReason
    } = this.props;
    
    if (suspendedReason) {
      if (!suspended_no_email || !suspended_pending_email) {
        return null;
      }
      if (suspendedReason === "EMAIL_NOT_EXIST") {
        const { amRole } = window.reactGlobals;
        const customerRole = amRole && typeof amRole === "string" ? amRole.toLowerCase() : "";

        return (
          <Alert hideCloseIcon alertType="warning">
            {convertStringToElements(
              customerRole === "prepay"
                ? suspended_no_email.section_prepayDescription
                : suspended_no_email.section_postpayDescription
            )}
          </Alert>
        );
      } else {
        return (
          <Alert hideCloseIcon alertType="warning">
            {convertStringToElements(suspended_pending_email.section_description)}
          </Alert>
        );
      }
    }

    if (cancelDownloadType === "delete" || cancelDownloadType === "cancel") {
      let text = "";
      if (cancelDownloadType === "delete") {
        text = pageContent.delete_file_banner.section_title;
      } else {
        text = pageContent.cancel_request_banner.section_title;
      }
      return (
        <Alert alertType="success" afterCloseRequest={this.props.resetCancelDownloadType}>
          {text}
        </Alert>
      );
    }

    if (shouldBannerRender) {
      if (requestType === "DOWNLOAD" || requestType === "DOWNLOAD_AFFIDAVIT") {
        if (status === "COMPLETED" && downloadReady) {
          return (
            <Alert alertType="success" hideCloseIcon>
              {convertStringToElements(download_complete.section_description)}
            </Alert>
          );
        } else if (status !== "COMPLETED") {
          const content =
            (checkAMLob() === "vzw" || checkAMLob() === "vzt") && hasExtension
              ? replaceHashValues(download_extension.section_description, {
                  lastExtensionTaken: lastExtensionTaken
                })
              : generic_error.section_description;
          return (
            <Alert alertType="copycliboard" hideCloseIcon>
              {convertStringToElements(content)}
            </Alert>
          );
        }
      } else if (requestType === "DELETE") {
        if (status === "COMPLETED") {
          return (
            <Alert alertType="success" hideCloseIcon>
              {convertStringToElements(delete_complete.section_description)}
            </Alert>
          );
        } else if (status !== "COMPLETED") {
          return (
            <Alert alertType="info" hideCloseIcon>
              {convertStringToElements(generic_error.section_description)}
            </Alert>
          );
        }
      } else if (requestType === "APPEAL") {
        if (status === "COMPLETED") {
          // Will deal it later.
          /*
          return (
            <Alert alertType="success" hideCloseIcon>
              {convertStringToElements(delete_complete.section_description)}
            </Alert>
          );
          */
        } else if (status !== "COMPLETED") {
          return (
            <Alert alertType="info" hideCloseIcon>
              {convertStringToElements(appeal_pending.section_description)}
            </Alert>
          );
        }
      } else if (requestType === "CORRECT") {
        if (status === "IN_PROGRESS") {
          return (
            <Alert alertType="info" hideCloseIcon>
              {convertStringToElements(correct_in_progress.section_description)}
            </Alert>
          );
        }
      }
      

    }

    return null;
  };

  render() {
    return <div>{this.renderMainHeaderButton()} </div>;
  }
}

const mapStateToProps = ({
  downloadAndDelete: {
    requestType,
    status,
    downloadReady,
    loggedInMtn,
    shouldBannerRender,
    lastExtensionTaken,
    hasExtension,
    suspendedReason
  },
  cancelDownloadType,
  pageContent
}) => ({
  requestType,
  status,
  downloadReady,
  cancelDownloadType,
  loggedInMtn,
  shouldBannerRender,
  lastExtensionTaken,
  hasExtension,
  pageContent,
  suspendedReason
});

YourRequestBanner.propTypes = {
  requestType: PropTypes.string,
  status: PropTypes.string,
  fetchDownloadAndDeleteLanding: PropTypes.func.isRequired,
  bannerContent: PropTypes.object.isRequired
};

export default compose(
  connect(
    mapStateToProps,
    { fetchDownloadAndDeleteLanding, resetCancelDownloadType }
  ),
  withRouter
)(YourRequestBanner);
